module["exports"] = [
  "Västra",
  "Östra",
  "Norra",
  "Södra",
  "Övre",
  "Undre"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_prefix.js
// module id = 1376
// module chunks = 0